export const PACKAGES_CREATE_EDIT_OPEN_MODAL = "PACKAGES_CREATE_EDIT_OPEN_MODAL";

export const PACKAGES_CREATE_PACKAGE_REQUEST = "PACKAGES_CREATE_PACKAGE_REQUEST";
export const PACKAGES_CREATE_PACKAGE_RESULT = "PACKAGES_CREATE_PACKAGE_RESULT";

export const PACKAGES_UPDATE_PACKAGE_REQUEST = "PACKAGES_UPDATE_PACKAGE_REQUEST";
export const PACKAGES_UPDATE_PACKAGE_RESULT = "PACKAGES_UPDATE_PACKAGE_RESULT";

export const PACKAGES_GET_PACKAGE_REQUEST = "PACKAGES_GET_PACKAGE_REQUEST";
export const PACKAGES_GET_PACKAGE_RESULT = "PACKAGES_GET_PACKAGE_RESULT";